"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
var _BaseComponents = require("../../StyledComponents/BaseComponents");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MediaGallery = _interopRequireDefault(require("./PageComponents/MediaGallery"));
var _VariancePicker = _interopRequireDefault(require("./PageComponents/VariancePicker"));
var _RangeSliders = _interopRequireDefault(require("./PageComponents/RangeSliders"));
var _ConnectivityPlan = _interopRequireDefault(require("./PageComponents/ConnectivityPlan"));
var _PaymentSummary = _interopRequireDefault(require("./PageComponents/PaymentSummary"));
var _PaymentInfo = _interopRequireDefault(require("./PageComponents/PaymentInfo"));
var _useAccessory = require("../../../hooks/upsell/useAccessory");
var _constants = require("../../../utils/constants");
var _widgetSelectors = require("../../../store/widget/widgetSelectors");
var _useAppSelector = require("../../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const GrayGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
const LightGridRow = (0, _BaseComponents.LightBackground)(_r10SourceLibrary.GridRow);
const LightContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  padding: 1px 20px 20px 20px;
`;
const UpsellDetailsBody = () => {
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    currentVariant,
    paymentInfo,
    plans,
    handleSliderValuesChange,
    handleAddToCart,
    resetSlidersValues,
    currentVariantCharacteristicValueByName
  } = (0, _useAccessory.useAccessory)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const images = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.media.map(image => ({
    id: image.id,
    src: image.url
  }));
  const showConnectivityPlan = plans.length > 0 && !currentVariantCharacteristicValueByName(_constants.UPSELL_ACCESSORIES_CHARACTERISTICS_NAMES.WIFI_ONLY);
  const addToCart = () => {
    handleAddToCart();
    resetSlidersValues();
  };
  const StyledGridRow = showModalView ? GrayGridRow : LightGridRow;
  return /*#__PURE__*/_react.default.createElement(LightContainer, {
    id: "upsell-details-body"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    justify: "center",
    size: 2,
    weight: 3
  }, _services.locale.localeString('AccessoryModal.Header'), " ", currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.name)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, !!(images !== null && images !== void 0 && images.length) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_MediaGallery.default, {
    images: images
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: breakpoints.sm ? {
      bottom: 5
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_VariancePicker.default, null)))), /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_RangeSliders.default, {
    onChangePaymentValues: sliderValues => handleSliderValuesChange(sliderValues)
  }), /*#__PURE__*/_react.default.createElement(_PaymentInfo.default, {
    payment: paymentInfo
  })), showConnectivityPlan && /*#__PURE__*/_react.default.createElement(_ConnectivityPlan.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_PaymentSummary.default, {
    payment: paymentInfo,
    onAdd: addToCart
  })))));
};
var _default = UpsellDetailsBody;
exports.default = _default;